// extracted by mini-css-extract-plugin
export default {"definitionList":"definitionList---Mv7oV"};